<adapt-universal-dashboard-element name="Vision"
                                   [url]="visionUrl$ | async"
                                   linkText="View vision details">
    @if (visionSummary) {
        <div [froalaView]="visionSummary"></div>
    } @else {
        <adapt-call-to-action-inline [featureUrl]="visionUrl$ | async"> Capture and maintain the owner's team vision
        </adapt-call-to-action-inline>
    }
</adapt-universal-dashboard-element>
